import { render, staticRenderFns } from "./CIcon.vue?vue&type=template&id=95b9b588&"
import script from "./CIcon.vue?vue&type=script&lang=ts&"
export * from "./CIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports